import React from 'react';
import JustificationContainer from '~/components/atom/JustificationContainer';
import { Heading5 } from '~/components/atom/Typography';
import Checkbox from '~/components/molecule/Checkbox';
import Textarea from '~/components/molecule/Textarea';
import type { Lfa_Conversion_Data_Rejection_Criteria } from '~/graphql/types';
import Divider from '~/components/atom/Divider';
import type { ValidationError } from '~/components/page/LFA/state/validationState';
import ErrorBlock from '../ErrorBlock';

const text = {
  textarea: {
    label:
      'Voeg een notitie toe aan de herinnering. Dit helpt om later op te volgen.',
    placeholder: 'Voer een aangepaste reden in',
  },
};

export type Props = {
  dataTestId?: string;
  className?: string;
  error?: ValidationError;
  rejectionCriteria: Array<Lfa_Conversion_Data_Rejection_Criteria>;
  selectedCriteria: Array<Lfa_Conversion_Data_Rejection_Criteria>;
  customReason: string;
  question?: string;
  setCustomReason: (reason: string) => void;
  handleRejectionCriteriaChange: (
    criterion: Lfa_Conversion_Data_Rejection_Criteria,
  ) => void;
};

const RejectBlock: React.FCC<Props> = ({
  dataTestId,
  className,
  handleRejectionCriteriaChange,
  rejectionCriteria,
  selectedCriteria,
  customReason,
  setCustomReason,
  error,
  question = 'Waarom is de dienst niet geleverd?',
}) => (
  <JustificationContainer
    direction="column"
    gap="xxs"
    margin={[null, null, null, 'xxxs']}
    width="100%"
    dataTestId={dataTestId}
    className={className}
  >
    <Divider margin={['xxs', null, null, null]} width="100%" />
    <Heading5 required margin={[null]}>
      {question}
    </Heading5>
    {error && <ErrorBlock error={error} />}
    {rejectionCriteria.map(criterion => (
      <Checkbox
        key={criterion.id}
        label={criterion.label}
        value={selectedCriteria.some(r => r.id === criterion.id)}
        onChange={() => handleRejectionCriteriaChange(criterion)}
      />
    ))}
    {selectedCriteria.some(r => r.id === 'custom_reason') && (
      <JustificationContainer width="100%">
        <Textarea
          name="custom-reason"
          value={customReason}
          onChange={value => setCustomReason(value || '')}
          placeholder={text.textarea.placeholder}
        />
      </JustificationContainer>
    )}
  </JustificationContainer>
);

export default RejectBlock;
